import { render, staticRenderFns } from "./KnowledgeBaseEdit.vue?vue&type=template&id=d1fb7fa4&scoped=true&"
import script from "./KnowledgeBaseEdit.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fb7fa4",
  null
  
)

export default component.exports